import store from "@/core/services/store";

let unwatchPresentation = null;

/**
 * O borrao de CSS so entra quando o servidor NAO esta cobrindo (WEL-5344).
 *
 * Com o motor de anonimizacao ligado o dado ja chega mascarado e legivel
 * ("M****" em vez do valor), e borrar por cima devolveria o problema que o
 * projeto veio resolver: a tela ilegivel, sem ganho de privacidade nenhum,
 * porque o valor real nem esta mais na resposta.
 *
 * Com o motor desligado ou em modo relatorio, o borrao continua sendo a unica
 * cobertura que existe e por isso continua valendo.
 */
const updatePresentationClass = () => {
  if (typeof document === "undefined") return;

  const cobrirNoNavegador =
    store.getters["isPresentationMode"] && !store.getters["anonimizacaoAtiva"];

  document.documentElement.classList.toggle(
    "presentation-mode-active",
    cobrirNoNavegador
  );
};

const ensurePresentationWatcher = () => {
  if (unwatchPresentation || typeof document === "undefined") return;

  updatePresentationClass();

  unwatchPresentation = store.watch(
    (state) => state.presentation.mascaraForcada,
    updatePresentationClass
  );
};

ensurePresentationWatcher();

export default {
  bind(el) {
    ensurePresentationWatcher();
    el.classList.add("presentation-blur-target");
  },
  unbind(el) {
    el.classList.remove("presentation-blur-target");
  }
};
